import { Breadcrumbs } from "AbstractElements";
import Blog from "Component/Blog";

const BlogList = () => {
	return (
		<>
			<Breadcrumbs parent="Blog" title="Daftar Blog" />
			<Blog />
		</>
	);
};
export default BlogList;